import { RootState } from '../../Presentation/store';

export const selectUrlRankState = (state: RootState) => state.urlRank;
export const selectUrlRankLoading = (state: RootState) => state.urlRank.loading;
export const selectUrlRankResult = (state: RootState) => state.urlRank.result;
export const selectUrlRankError = (state: RootState) => state.urlRank.error;
